<script>
import PC12 from '@/components/svg/PC12'
import PC24 from '@/components/svg/PC24'
import SF50 from '@/components/svg/SF50'
import Seat from '@/components/svg/Seat'
import formatCurrency from '@/utils/formatCurrency'

export default {
  components: { PC12, PC24, SF50, Seat },
  props: {
		icon: { type: String, required: true },
		name: { type: String, required: true },
		perHour: { type: Number, required: true },
  },
  methods: {
    formatCurrency,
  },
}
</script>

<template>
	<div class="flex flex-col items-center">
		<component
			:is="icon"
			class="flex-shrink-0"
			style="width: 100px; height: 26px;"
		/>
		<span class="mt-5 text-grey-700 text-center text-base font-medium tracking-widest uppercase">{{ name }}</span>
		<span
			class="mt-2 text-grey-700 text-center text-base font-medium leading-tight"
			style="text-wrap-style: balance;"
		>
			<span>{{ formatCurrency(perHour) }} / hour for 1</span>
			&nbsp;<Seat class="inline mb-1 h-4 w-4 flex-shrink-0" />
		</span>
	</div>
</template>
